import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import FileDownload from 'js-file-download';

import { StyledExportButton } from './css';
import { apiHost, config } from '../utils/request';

const EXPORT_FILE_NAME = 'orders.xlsx';

const ExportButton = ({ exportType, label, loadingLabel, filterPayload }) => {
  const [isExport, setIsExport] = useState();

  const className =
    isExport === exportType ? 'fa  fa-circle-o-notch fa-spin' : 'fa fa-spin';

  const onClick = async () => {
    if (isExport) return;

    const reqUrl = `${apiHost}/orders/export`;
    const reqBody = { ...filterPayload, exportType };
    const reqConfig = { ...config(), responseType: 'arraybuffer' };
    setIsExport(exportType);
    const res = await axios.post(reqUrl, reqBody, reqConfig);
    setIsExport();
    FileDownload(res.data, EXPORT_FILE_NAME);
  };

  return (
    <StyledExportButton onClick={onClick} className="buttonload">
      <i className={className} />
      {isExport === exportType ? loadingLabel : label}
    </StyledExportButton>
  );
};

ExportButton.propTypes = {
  exportType: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  loadingLabel: PropTypes.string.isRequired,
  filterPayload: PropTypes.objectOf(PropTypes.any)
};

ExportButton.defaultProps = {
  filterPayload: {}
};

export default ExportButton;
